module.exports = __webpack_public_path__ + "static/img/illu_de_04.fb5e077.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illus/illu_de_04.png
// module id = xnMC
// module chunks = 1